// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_header_container__RnJMT {
  height: var(--header-height);
  padding: 0 10px 0 24px;
  display: flex;
  position: sticky;
  top: 0;
  z-index: var(--header-z-index);
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  opacity: 1;
  transition: height 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.header_header_container__RnJMT .header_logo_link__KSgkY {
  height: 100%;
  border-radius: 50%;
}
.header_header_container__RnJMT .header_logo_link__KSgkY img {
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
}
.header_header_container__RnJMT .header_logo_link__KSgkY a::before {
  content: none;
}
.header_header_container__RnJMT .header_main_section__lGNYN {
  padding: 10px 0;
  width: 100%;
  overflow: hidden;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 {
  display: none;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_link_margin__VVaTL {
  margin-right: 30px;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R button:last-of-type {
  margin-left: 30px;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_action_menu__gUH\\+6 {
  display: flex;
  align-items: center;
}
.header_header_container__RnJMT .header_main_section__lGNYN .header_bottom_part__pcQ5n {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
@media (max-width: 1199px) {
  .header_header_container__RnJMT {
    height: 100px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN {
    padding: 10px 0;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button {
    padding: 8px 15px;
    font-size: 12px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button:last-of-type {
    margin-left: 15px;
  }
}
@media (max-width: 991px) {
  .header_header_container__RnJMT {
    padding: 0 5px;
  }
  .header_header_container__RnJMT .header_logo_link__KSgkY {
    height: var(--header-height-less);
    transition: height 0.3s ease-in-out;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button {
    padding: 6px 10px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button:last-of-type {
    margin-left: 10px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_bottom_part__pcQ5n {
    margin-top: 10px;
  }
}
@media (max-width: 768px) {
  .header_header_container__RnJMT {
    height: 70px;
  }
  .header_header_container__RnJMT .header_logo_link__KSgkY {
    height: 70px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 {
    width: 26px;
    height: 26px;
    display: block;
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translateY(-50%);
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 {
    display: flex;
    align-items: center;
    padding-left: 0;
    position: absolute;
    top: 0;
    right: 0;
    width: 26px;
    height: 26px;
    cursor: pointer;
    z-index: 1;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 > span,
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 > span::before,
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: var(--primary-color);
    transition-duration: 0.25s;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 > span::before {
    content: "";
    top: -8px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_btn__0OWg0 > span::after {
    content: "";
    top: 8px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_open__8qvrY > span {
    transform: rotate(45deg) !important;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_open__8qvrY > span::before {
    top: 0;
    transform: rotate(0);
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .header_burger__Ysdu4 .header_menu_open__8qvrY > span::after {
    top: 0;
    transform: rotate(90deg);
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button {
    padding: 4px 8px;
    font-size: 10px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_top_part__MQ9\\+R .button:last-of-type {
    margin-left: 8px;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_bottom_part__pcQ5n {
    height: 0;
    overflow: hidden;
    margin-top: 0;
  }
  .header_header_container__RnJMT .header_main_section__lGNYN .header_bottom_part__pcQ5n.header_menu_open__8qvrY {
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 35px;
    overflow: visible;
    background-color: #fff;
    padding: 5px 7px;
  }
}

.header_cooky_banner__NsLE9 {
  position: fixed;
  bottom: 20px;
  right: 20px;
  max-width: 500px;
  padding: 20px 30px;
  background-color: #c3dfd4;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border: 1px solid var(--primary-color);
  border-radius: 16px;
  font-size: 14px;
}
.header_cooky_banner__NsLE9 .header_title__jg1ZW {
  font-size: 16px;
  font-weight: bold;
}
.header_cooky_banner__NsLE9 .header_buttons__ST-BX {
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: space-around;
}
.header_cooky_banner__NsLE9 .header_buttons__ST-BX button {
  padding: 8px 18px;
  border: 1px solid #fff;
  border-radius: 5px;
  background-color: #fff;
  color: var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.header_cooky_banner__NsLE9 .header_buttons__ST-BX button:hover {
  border: 1px solid var(--primary-color);
}
.header_cooky_banner__NsLE9 .header_buttons__ST-BX button:last-child {
  color: #565656;
}
.header_cooky_banner__NsLE9 .header_buttons__ST-BX button:last-child:hover {
  border: 1px solid #565656;
}
@media (max-width: 768px) {
  .header_cooky_banner__NsLE9 {
    font-size: 12px;
    padding: 15px 20px;
    gap: 10px;
  }
  .header_cooky_banner__NsLE9 .header_title__jg1ZW {
    font-size: 14px;
  }
}

.header_header_less__l2Cag {
  height: var(--header-height-less);
  opacity: 0.9;
}

.header_ContactUsModal__yt\\+tT .header_ContactUsModalContent__TW\\+XZ {
  padding: 50px;
}
.header_ContactUsModal__yt\\+tT .header_ContactUsModalContent__TW\\+XZ h2 {
  font-size: 26px !important;
}
.header_ContactUsModal__yt\\+tT .header_modalText__8Wlzs {
  text-align: center;
  font-size: 18px;
}

@media (max-width: 768px) {
  .header_header_container_menu_open__uvOIx {
    height: 100px;
  }
}
.header_form_field__6ScbK {
  margin-bottom: 10px;
}
.header_form_field__6ScbK label {
  display: block;
  font-weight: bold;
}
.header_form_field__6ScbK input {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.header_form_actions__VrgLR {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.header_form_actions__VrgLR button {
  margin-left: 10px;
}

.header_content_wrap__RveMV {
  padding: 11px 20px;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}
.header_content_wrap__RveMV:hover {
  background-color: #fafbfd;
  color: var(--primary-color);
}
.header_content_wrap__RveMV:active {
  background-color: #fafbfd;
  color: var(--primary-color);
}
.header_content_wrap__RveMV .header_content__JemRP {
  rotate: 90deg;
  height: 12px;
  margin-left: 20px;
}
.header_content_wrap__RveMV .header_content__JemRP img {
  height: 100%;
  object-fit: contain;
}
@media (max-width: 991px) {
  .header_content_wrap__RveMV {
    font-size: 14px;
  }
}

.header_order_call_modal__mSFCB {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header_order_call_modal__mSFCB:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.header_order_call_modal__mSFCB:nth-child(3) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.header_sign_up_modal__a4tjl:nth-child(2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.header_sign_up_modal__a4tjl:nth-child(3) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.header_view_more_button__SrLf2 {
  display: flex;
  margin: 0 auto;
  margin-top: 20px;
  padding: 15px 24px;
  border-radius: 12px;
}
@media (max-width: 1199px) {
  .header_view_more_button__SrLf2 {
    padding: 10px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Header/header.module.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,MAAA;EACA,8BAAA;EACA,sBAAA;EACA,yCAAA;EACA,UAAA;EACA,6DACE;AAAJ;AAGE;EACE,YAAA;EACA,kBAAA;AADJ;AAEI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AAGM;EACE,aAAA;AADR;AAME;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAJJ;AAMI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAJN;AAMM;EACE,aAAA;AAJR;AAOM;EACE,kBAAA;AALR;AASQ;EACE,iBAAA;AAPV;AAWM;EACE,aAAA;EACA,mBAAA;AATR;AAaI;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAXN;AAeE;EAnEF;IAoEI,aAAA;EAZF;EAcE;IACE,eAAA;EAZJ;EAcM;IACE,iBAAA;IACA,eAAA;EAZR;EAcQ;IACE,iBAAA;EAZV;AACF;AAkBE;EArFF;IAsFI,cAAA;EAfF;EAiBE;IACE,iCAAA;IACA,mCAAA;EAfJ;EAoBM;IACE,iBAAA;EAlBR;EAoBQ;IACE,iBAAA;EAlBV;EAuBI;IACE,gBAAA;EArBN;AACF;AAyBE;EA9GF;IA+GI,YAAA;EAtBF;EAwBE;IACE,YAAA;EAtBJ;EA2BM;IACE,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;IACA,UAAA;IACA,2BAAA;EAzBR;EA2BQ;IACE,aAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,MAAA;IACA,QAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,UAAA;EAzBV;EA4BQ;;;IAGE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,sCAAA;IACA,0BAAA;EA1BV;EA4BQ;IACE,WAAA;IACA,SAAA;EA1BV;EA4BQ;IACE,WAAA;IACA,QAAA;EA1BV;EA6BQ;IACE,mCAAA;EA3BV;EA6BQ;IACE,MAAA;IACA,oBAAA;EA3BV;EA6BQ;IACE,MAAA;IACA,wBAAA;EA3BV;EA+BM;IACE,gBAAA;IACA,eAAA;EA7BR;EA+BQ;IACE,gBAAA;EA7BV;EAkCI;IACE,SAAA;IACA,gBAAA;IACA,aAAA;EAhCN;EAmCI;IACE,kBAAA;IACA,YAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,sBAAA;IACA,gBAAA;EAjCN;AACF;;AAsCA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;EACA,mBAAA;EACA,eAAA;AAnCF;AAqCE;EACE,eAAA;EACA,iBAAA;AAnCJ;AAsCE;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,6BAAA;AApCJ;AAsCI;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gCAAA;AApCN;AAsCM;EACE,sCAAA;AApCR;AAuCM;EACE,cAAA;AArCR;AAuCQ;EACE,yBAAA;AArCV;AA2CE;EAlDF;IAmDI,eAAA;IACA,kBAAA;IACA,SAAA;EAxCF;EA0CE;IACE,eAAA;EAxCJ;AACF;;AA4CA;EACE,iCAAA;EACA,YAAA;AAzCF;;AAiDE;EACE,aAAA;AA9CJ;AAgDI;EACE,0BAAA;AA9CN;AAiDE;EACE,kBAAA;EACA,eAAA;AA/CJ;;AAmDA;EACE;IACE,aAAA;EAhDF;AACF;AAmDA;EACE,mBAAA;AAjDF;AAmDE;EACE,cAAA;EACA,iBAAA;AAjDJ;AAoDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AAlDJ;;AAsDA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAnDF;AAqDE;EACE,iBAAA;AAnDJ;;AAuDA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AApDF;AAsDE;EACE,yBAAA;EACA,2BAAA;AApDJ;AAuDE;EACE,yBAAA;EACA,2BAAA;AArDJ;AAwDE;EACE,aAAA;EACA,YAAA;EACA,iBAAA;AAtDJ;AAwDI;EACE,YAAA;EACA,mBAAA;AAtDN;AA0DE;EA7BF;IA8BI,eAAA;EAvDF;AACF;;AA0DA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAvDF;AAyDE;EACE,0BAAA;EACA,6BAAA;AAvDJ;AAyDE;EACE,yBAAA;EACA,4BAAA;AAvDJ;;AA4DE;EACE,0BAAA;EACA,6BAAA;AAzDJ;AA2DE;EACE,yBAAA;EACA,4BAAA;AAzDJ;;AA6DA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA1DF;AA4DE;EAPF;IAQI,kBAAA;EAzDF;AACF","sourcesContent":[".header_container {\n  height: var(--header-height);\n  padding: 0 10px 0 24px;\n  display: flex;\n  position: sticky;\n  top: 0;\n  z-index: var(--header-z-index);\n  background-color: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);\n  opacity: 1;\n  transition:\n    height 0.3s ease-in-out,\n    opacity 0.3s ease-in-out;\n\n  .logo_link {\n    height: 100%;\n    border-radius: 50%;\n    img {\n      height: 100%;\n      object-fit: contain;\n      border-radius: 50%;\n    }\n    a {\n      &::before {\n        content: none;\n      }\n    }\n  }\n\n  .main_section {\n    padding: 10px 0;\n    width: 100%;\n    overflow: hidden;\n\n    .top_part {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      position: relative;\n\n      .burger {\n        display: none;\n      }\n\n      .link_margin {\n        margin-right: 30px;\n      }\n\n      button {\n        &:last-of-type {\n          margin-left: 30px;\n        }\n      }\n\n      .action_menu {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    .bottom_part {\n      display: flex;\n      justify-content: space-between;\n      margin-top: 15px;\n    }\n  }\n\n  @media (max-width: 1199px) {\n    height: 100px;\n\n    .main_section {\n      padding: 10px 0;\n      .top_part {\n        :global(.button) {\n          padding: 8px 15px;\n          font-size: 12px;\n\n          &:last-of-type {\n            margin-left: 15px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 991px) {\n    padding: 0 5px;\n\n    .logo_link {\n      height: var(--header-height-less);\n      transition: height 0.3s ease-in-out;\n    }\n\n    .main_section {\n      .top_part {\n        :global(.button) {\n          padding: 6px 10px;\n\n          &:last-of-type {\n            margin-left: 10px;\n          }\n        }\n      }\n\n      .bottom_part {\n        margin-top: 10px;\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    height: 70px;\n\n    .logo_link {\n      height: 70px;\n    }\n\n    .main_section {\n      .top_part {\n        .burger {\n          width: 26px;\n          height: 26px;\n          display: block;\n          position: absolute;\n          top: 50%;\n          left: 20px;\n          transform: translateY(-50%);\n\n          .menu_btn {\n            display: flex;\n            align-items: center;\n            padding-left: 0;\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 26px;\n            height: 26px;\n            cursor: pointer;\n            z-index: 1;\n          }\n\n          .menu_btn > span,\n          .menu_btn > span::before,\n          .menu_btn > span::after {\n            display: block;\n            position: absolute;\n            width: 100%;\n            height: 2px;\n            background-color: var(--primary-color);\n            transition-duration: 0.25s;\n          }\n          .menu_btn > span::before {\n            content: \"\";\n            top: -8px;\n          }\n          .menu_btn > span::after {\n            content: \"\";\n            top: 8px;\n          }\n\n          .menu_open > span {\n            transform: rotate(45deg) !important;\n          }\n          .menu_open > span::before {\n            top: 0;\n            transform: rotate(0);\n          }\n          .menu_open > span::after {\n            top: 0;\n            transform: rotate(90deg);\n          }\n        }\n\n        :global(.button) {\n          padding: 4px 8px;\n          font-size: 10px;\n\n          &:last-of-type {\n            margin-left: 8px;\n          }\n        }\n      }\n\n      .bottom_part {\n        height: 0;\n        overflow: hidden;\n        margin-top: 0;\n      }\n\n      .bottom_part.menu_open {\n        position: absolute;\n        bottom: -5px;\n        left: 0;\n        width: 100%;\n        height: 35px;\n        overflow: visible;\n        background-color: #fff;\n        padding: 5px 7px;\n      }\n    }\n  }\n}\n\n.cooky_banner {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  max-width: 500px;\n  padding: 20px 30px;\n  background-color: #c3dfd4;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  border: 1px solid var(--primary-color);\n  border-radius: 16px;\n  font-size: 14px;\n\n  .title {\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  .buttons {\n    width: 100%;\n    display: flex;\n    gap: 10px;\n    justify-content: space-around;\n\n    button {\n      padding: 8px 18px;\n      border: 1px solid #fff;\n      border-radius: 5px;\n      background-color: #fff;\n      color: var(--primary-color);\n      cursor: pointer;\n      transition: all 0.3s ease-in-out;\n\n      &:hover {\n        border: 1px solid var(--primary-color);\n      }\n\n      &:last-child {\n        color: #565656;\n\n        &:hover {\n          border: 1px solid #565656;\n        }\n      }\n    }\n  }\n\n  @media (max-width: 768px) {\n    font-size: 12px;\n    padding: 15px 20px;\n    gap: 10px;\n\n    .title {\n      font-size: 14px;\n    }\n  }\n}\n\n.header_less {\n  height: var(--header-height-less);\n  opacity: 0.9;\n}\n\n.ContactUsModal {\n  // :global(.comment_content_wrap) {\n  //   width: fit-content;\n  // }\n\n  .ContactUsModalContent {\n    padding: 50px;\n\n    h2 {\n      font-size: 26px !important;\n    }\n  }\n  .modalText {\n    text-align: center;\n    font-size: 18px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header_container_menu_open {\n    height: calc(70px + 30px);\n  }\n}\n\n.form_field {\n  margin-bottom: 10px;\n\n  label {\n    display: block;\n    font-weight: bold;\n  }\n\n  input {\n    width: 100%;\n    padding: 8px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n  }\n}\n\n.form_actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n\n  button {\n    margin-left: 10px;\n  }\n}\n\n.content_wrap {\n  padding: 11px 20px;\n  margin: 20px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #fff;\n\n  &:hover {\n    background-color: #fafbfd;\n    color: var(--primary-color);\n  }\n\n  &:active {\n    background-color: #fafbfd;\n    color: var(--primary-color);\n  }\n\n  .content {\n    rotate: 90deg;\n    height: 12px;\n    margin-left: 20px;\n\n    img {\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n\n  @media (max-width: 991px) {\n    font-size: 14px;\n  }\n}\n\n.order_call_modal {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  &:nth-child(2) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  &:nth-child(3) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n\n.sign_up_modal {\n  &:nth-child(2) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  &:nth-child(3) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n}\n\n.view_more_button {\n  display: flex;\n  margin: 0 auto;\n  margin-top: 20px;\n  padding: 15px 24px;\n  border-radius: 12px;\n\n  @media (max-width: 1199px) {\n    padding: 10px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header_container": `header_header_container__RnJMT`,
	"logo_link": `header_logo_link__KSgkY`,
	"main_section": `header_main_section__lGNYN`,
	"top_part": `header_top_part__MQ9+R`,
	"burger": `header_burger__Ysdu4`,
	"link_margin": `header_link_margin__VVaTL`,
	"action_menu": `header_action_menu__gUH+6`,
	"bottom_part": `header_bottom_part__pcQ5n`,
	"menu_btn": `header_menu_btn__0OWg0`,
	"menu_open": `header_menu_open__8qvrY`,
	"cooky_banner": `header_cooky_banner__NsLE9`,
	"title": `header_title__jg1ZW`,
	"buttons": `header_buttons__ST-BX`,
	"header_less": `header_header_less__l2Cag`,
	"ContactUsModal": `header_ContactUsModal__yt+tT`,
	"ContactUsModalContent": `header_ContactUsModalContent__TW+XZ`,
	"modalText": `header_modalText__8Wlzs`,
	"header_container_menu_open": `header_header_container_menu_open__uvOIx`,
	"form_field": `header_form_field__6ScbK`,
	"form_actions": `header_form_actions__VrgLR`,
	"content_wrap": `header_content_wrap__RveMV`,
	"content": `header_content__JemRP`,
	"order_call_modal": `header_order_call_modal__mSFCB`,
	"sign_up_modal": `header_sign_up_modal__a4tjl`,
	"view_more_button": `header_view_more_button__SrLf2`
};
export default ___CSS_LOADER_EXPORT___;
